export default __webpack_public_path__ + "cb105d000ee7da1d4022bf2061eda0b3.glb";